import dayjs from "dayjs";
import { numberFormat } from "utils";
import printDataTable from "utils/printDataTable";
import { printColumnHeader } from "./columns";

export const printSubcontractPV = ({ pvData, msData }) => {
  let titleDetail = []
  let sumTotal = 0;
  let sumWhtPr = 0;
  const whtPrObjs = []
  for (const row of pvData.Exps) {
    if (row.id > 0) {
      sumTotal += +row.Total
      sumWhtPr += +row.WhtPr
    }
    for (const exp of row.RawExps || []) {
      if (exp.WhtPrct === 0) continue
      const found = whtPrObjs.find(obj => obj.WhtPrct === exp.WhtPrct)
      if(found){
        found.WhtPr = +found.WhtPr + +exp.WhtPr
      } else {
        whtPrObjs.push({WhtPrct: exp.WhtPrct, WhtPr: exp.WhtPr})
      }
    }

    const payAmnt = +row.Total - +row.WhtPr
    row.No = (row.No && row.No.toString()) || "-"
    row.ContNo = row.ContNo || "-"
    row.AptTm = (row.AptTm && dayjs(row.AptTm).format("DD/MM/YYYY")) || "-"
    row.ScInvDte = (row.ScInvDte && dayjs(row.ScInvDte).format("DD/MM/YYYY")) || "-"
    row.OwnRcptAmnt = numberFormat(+row.OwnRcptAmnt)
    row.CusRcptAmnt = numberFormat(+row.CusRcptAmnt)
    row.TrnsAmnt = numberFormat(+row.TrnsAmnt)
    row.Total = numberFormat(+row.Total)
    row.PayAmnt = numberFormat(payAmnt)
    row.WhtPr = numberFormat(+row.WhtPr)
  }
  const whtObjPrint  = whtPrObjs.map(obj => ({ 
    header: `ยอดรวมหัก ณ ที่จ่าย ${obj.WhtPrct}%:`, 
    value: `${numberFormat(obj.WhtPr)} บาท`, 
    headerWidth: 1.3, 
    valueWidth: 1.3, 
    align: "right" 
  }))

  if (pvData.PV.PayMthdId === 2) {
    titleDetail = [
      { header: "รายละเอียด :", value: `ธนาคาร:${pvData.PV.ChqBkNm} สาขา:${pvData.PV.ChqBrch || "-"}`, headerWidth: 0.8 },
      { header: "", value: `วันที่เช็ค:${dayjs(pvData.PV.ChqDte).format("DD/MM/YYYY")} เลขที่เช็ค:${pvData.PV.ChqNo}`, headerWidth: 0.8 },
    ]
  } else if (pvData.PV.PayMthdId === 3) {
    titleDetail = [
      { header: "รายละเอียด :", value: `ธนาคาร:${pvData.PV.TrnBkNm} สาขา:${pvData.PV.TrnBkBrch || "-"}`, headerWidth: 0.8 },
      { header: "", value: `เลขที่บัญชี:${pvData.PV.TrnBkAccNo} ชื่อบัญชี:${pvData.PV.TrnAccNm}`, headerWidth: 0.8 },
      { header: "", value: `วันที่จ่ายเงิน:${dayjs(pvData.PV.PayDte).format("DD/MM/YYYY")} `, headerWidth: 0.8 },
    ]
  }
  const extraData = {
    title: [
      { header: "เลขที่เอกสาร :", value: pvData.PV.PVNo, headerWidth: 1 },
      { header: "วันที่เอกสาร :", value: dayjs(pvData.PV.PVDte).format("DD/MM/YYYY"), headerWidth: 1 },
      { header: "จำนวนเงิน :", value: numberFormat(+pvData.PV.PayAmnt) + " บาท", headerWidth: 1 },
    ],
    top: [
      { header: "ผู้รับเงิน :", value: pvData.Sc.Name, headerWidth: 0.8 },
      { header: "วิธีจ่ายเงิน :", value: pvData.PV.PayMthdNm, headerWidth: 0.8 },
      ...titleDetail
    ],
    bottom: [
      { header: "ยอดรวมแจ้งหนี้ :", value: `${numberFormat(sumTotal)} บาท`, headerWidth: 1.3, valueWidth: 1.3, align: "right" },
      //{ header: "ยอดรวมหัก ณ ที่จ่าย :", value: `${numberFormat(sumWhtPr)} บาท`, headerWidth: 1.1, valueWidth: 1.3, align: "right" },
      ...whtObjPrint,
      { header: "ยอดจ่าย :", value: `${numberFormat(sumTotal - sumWhtPr)} บาท`, headerWidth: 1.3, valueWidth: 1.3, align: "right" },
    ]
  }
  if (pvData.Exps.length > 0)
    pvData.Exps[pvData.Exps.length - 1].isBold = 1
  const printRow = []
  for(const row of pvData.Exps){
    const newData = {...row}
    delete newData.RawExps
    printRow.push(newData)
  }
  printDataTable({
    title: "รายงานการจ่ายเงิน",
    dataTable: printRow,
    companyData: msData.serverData.CompanyData,
    columnHeader: printColumnHeader,
    isShowSum: false,
    extraData: extraData
  })
}